import { render } from "./CustomerLoved.vue?vue&type=template&id=08adf435"
import script from "./CustomerLoved.vue?vue&type=script&lang=js"
export * from "./CustomerLoved.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__